import type { PropsWithChildren } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import _BaseLabel from './_BaseLabel'

export type NeutralLabelVariant = 'surfaceLight'

const NeutralLabelElement = styled(_BaseLabel)`
  &.variant-surfaceLight {
    background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
    border-color: ${props => props.theme.palette.neutral.surface.lightBackground};
    color: ${props => props.theme.palette.neutral.surface.lightContrast};
  }
`

interface Props {
  variant?: NeutralLabelVariant
  className?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
  format?: React.ComponentProps<typeof _BaseLabel>['format']
}

/**
 * Documentation: <https://aussiecommerce.atlassian.net/wiki/spaces/UXUI/pages/4504289338/Label>
 */
function NeutralLabel({ className, variant = 'surfaceLight', ...labelProps }: PropsWithChildren<Props>) {
  return <NeutralLabelElement
    className={clsx(
      className,
      `variant-${variant}`,
    )}
    {...labelProps}
  />
}

export default NeutralLabel
